export default "__VITE_ASSET__C_48INQF__ 100w";